import select from 'dom-select'
import on from 'dom-event'
import {
  set,
  unset,
  isMobile,
  contains
} from 'utils/general'

export default el => {
  select.all('.plp-nav--item__link[data-handle]', el).map(link => {
    on(link, 'click', (e) => {
      e.preventDefault()

      const menuHandle = e.target.dataset.handle

      select.all('.plp-subnav__container', el).map(submenu => {
        if (submenu.dataset.sub !== menuHandle) {
          submenu.style.maxHeight = 0
        }
      })

      const submenuElem = select(`.plp-subnav__container[data-sub="${menuHandle}"]`)

      if (!submenuElem) return false

      if (contains(submenuElem, 'expanded')) {
        submenuElem.style.maxHeight = 0
        unset(submenuElem, 'expanded')
      } else {
        const submentInner = select('.plp-subnav', submenuElem)

        submenuElem.style.maxHeight = `${submentInner.clientHeight}px`
        set(submenuElem, 'expanded')
      }
    })
  })
}
